export default {
  common: {
    email: 'Email',
    phone: 'Điện thoại',
    phoneNumber: 'Số điện thoại',
    countrySelect: 'Chọn quốc gia',
    countryUnmodifiedNote: 'Không thể thay đổi quốc gia sau khi đăng ký',
    next: 'Tiếp theo',
    back: 'Quay lại',
    attention: 'Lưu ý',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    modify: 'Sửa đổi',
    ignore: 'Bỏ qua',
    firstName: 'Tên',
    middleName: 'Tên đệm',
    lastName: 'Họ',
    gender: 'Giới tính',
    male: 'Nam',
    female: 'Nữ',
    birthday: 'Ngày sinh',
    graphicCode: 'Mã đồ họa',
    emailCode: 'Mã xác minh email',
    smsCode: 'Mã SMS',
    smsVerificationCode: 'Mã xác minh qua SMS',
    bind: 'Liên kết',
    send: 'Gửi',
    resend: 'Gửi lại',
    address: 'Địa chỉ',
    done: 'Xong',
    systemMessage: 'Tin nhắn hệ thống',
    setting: 'Cài đặt',
    submit: 'Gửi',
    language: 'Ngôn Ngữ',
    edit: 'Chỉnh sửa',
    delete: 'Xóa'
  },
  account: {
    account: 'Tài khoản',
    nickname: 'Biệt danh',
    id: 'ID',
    basicInfo: 'Cấp độ cơ bản',
    placeholder: 'Vui lòng nhập',
    completed: 'Đã hoàn tất',
    semiInfo: 'Đã xác minh một phần',
    fullyInfo: 'Đã xác minh đầy đủ',
    basicTab: 'Cơ bản',
    advancedTab: 'Nâng cao',
    linkedAccount: 'Tài khoản rút tiền được liên kết',
    accountSecurity: 'Tài khoản MetWallet và An toàn',
    logout: 'Đăng xuất',
    semiToast: 'Vui lòng hoàn tất xác minh Cấp độ cơ bản',
    fullyToast: 'Vui lòng hoàn tất xác minh Cấp độ cơ bản \n và Đã xác minh một phần',
    quickLoginTitle: 'Đăng nhập nhanh',
    cancelQuickLogin: 'Bạn có chắc chắn muốn tắt Đăng nhập nhanh không?'
  },
  accountSecurity: {
    title: 'Tài khoản và An toàn',
    payPwd: 'Mật khẩu thanh toán',
    loginPwd: 'Mật khẩu đăng nhập',
    changeEmail: 'Đổi email',
    changePhone: 'Đổi số điện thoại',
    changePayPwd: 'Đổi mật khẩu thanh toán',
    changeLoginPwd: 'Đổi mật khẩu đăng nhập',
    bindEmail: 'Liên kết email',
    bindEmailNote: 'Vượt qua xác minh email để liên kết',
    bindEmailPlaceholder: 'Nhập email bạn muốn liên kết',
    smsBindNote: 'Xác minh qua SMS để liên kết',
    bindPhone: 'Liên kết số điện thoại',
    smsAuthentication: 'Xác thực SMS',
    emailAuthentication: 'Xác thực email',
    phoneVerificationNote: 'Trước tiên, hãy vượt qua xác minh số điện thoại hiện tại',
    bindPhonePlaceholder: 'Nhập số điện thoại bạn muốn liên kết',
    verificationWrongToast: 'Vui lòng kiểm tra mã xác minh của bạn',
    phoneNumberEmptyToast: 'Vui lòng điền số điện thoại',
    verificationCodeEmptyToast: 'Vui lòng điền mã',
    wrongCodeToast: 'Mã sai',
    changeNote: 'Vui lòng xác minh để thay đổi.',
    newEmailVerification: 'Xác minh email mới',
    newEmailPlaceholder: 'Nhập email mới của bạn',
    change: 'Thay đổi',
    emailLowercaseToast: 'Email phải được viết thường.',
    newEmailEmptyToast: 'Vui lòng điền email mới',
    changeSuccessToast: 'Thay đổi thành công',
    phonePlaceholder: 'Nhập số điện thoại',
    currentEmail: 'Email hiện tại',
    passCurrentEmailVerificationFirst: 'Vượt qua xác minh email hiện tại trước',
    currentEmailVerification: 'Xác minh email hiện tại',
    smsVerification: 'Xác minh SMS',
    currentPhoneNumber: 'Số điện thoại hiện tại',
    currentPhoneVerification: 'Xác minh số điện thoại hiện tại',
    currentEmailAddress: 'Địa chỉ email hiện tại',
    phoneVerification: 'Xác minh số điện thoại',
    enterVerificationCode: 'Nhập mã xác minh',
    newPhoneNumber: 'Số điện thoại mới',
    newEmail: 'Email mới'
  },
  withdrawAccount: {
    selectAccountType: 'Chọn loại tài khoản',
    noBasicLevelVerificationDialog: 'Vui lòng hoàn tất xác minh Cấp độ cơ bản trước khi liên kết phương thức rút tiền.',
    bindNote: 'Vui lòng điền thông tin tài khoản chính xác, nếu không việc rút tiền của bạn sẽ bị ảnh hưởng.',
    bindBankAccount: 'Liên kết tài khoản ngân hàng',
    bindMobileMoneyAccount: 'Liên kết tài khoản Mobile Money',
    fieldEmptyToast: '{0} là bắt buộc',
    fieldLengthToast: '{0} phải chứa ít nhất {1} ký tự',
    bindBankRepeatToast: 'Không liên kết cùng một tài khoản ngân hàng nhiều lần!',
    accountName: 'Tên tài khoản',
    ifscCode: 'Mã IFSC',
    accountEmptyToast: 'Tài khoản là bắt buộc',
    accountNameEmptyToast: 'Tên tài khoản là bắt buộc',
    phoneEmptyToast: 'Số điện thoại là bắt buộc',
    emailEmptyToast: 'Email là bắt buộc',
    ifscCodeEmptyToast: 'Mã IFSC là bắt buộc',
    ifscCodeLengthToast: 'Mã IFSC phải gồm 11 chữ số',
    bindIMPSRepeatToast: 'Không liên kết cùng một tài khoản IMPS nhiều lần!',
    bindNote2:
      'Vui lòng điền đúng địa chỉ TRC-20 của bạn. Địa chỉ sai sẽ khiến thanh toán bị mất, chúng tôi không chịu bất kỳ trách nhiệm nào.',
    usdtAddress: 'Địa chỉ USDT (TRC-20):',
    minimumLimit: 'Số tiền rút tối thiểu cho mỗi giao dịch: $10',
    usdtFee: 'Phí: Áp dụng theo phí thực tế',
    registerGcash: 'Nếu bạn không có tài khoản Gcash, vui lòng nhấp vào đây để đăng ký.',
    registerEpay: 'Nếu bạn không có tài khoản Epay, vui lòng nhấp vào đây để đăng ký.',
    bindThirdPartyTitle: 'Liên kết tài khoản {0}',
    wrongAccountToast: 'Tài khoản sai',
    accountFormatToast: 'Định dạng tài khoản không đúng',
    bindThirdPartyFailedToast: '{0} liên kết không thành công',
    queryFailedToast: 'Truy vấn không thành công.',
    editFailedToast: 'Chỉnh sửa không thành công.',
    add: 'Thêm',
    confirmEditDialog: 'Bạn có chắc chắn muốn chỉnh sửa tài khoản {0} không?',
    payPwdRequireDialog: 'Vui lòng đặt mật khẩu thanh toán gồm 6 chữ số trước khi thêm tài khoản.',
    unbindFailedToast: 'Không thể hủy liên kết',
    cashOutSuccessNote: 'Thời gian đến dự kiến: trong vòng 7 ngày làm việc',
    requestSubmitted: 'Yêu cầu rút tiền đã được gửi',
    amountLimitToast1: 'Số tiền rút phải ≥$40,00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'Số tiền rút phải ≥${0},00',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'Mẹo: Tích lũy số tiền đến ${0} trước khi rút tiền sẽ giúp bạn tiết kiệm phí xử lý.',
    amountNotEnoughToast: 'Số tiền rút không đủ',
    exceedingLimitToast1: 'Số tiền rút hôm nay đã đạt đến hạn mức trên',
    exceedingLimitToast2:
      'Số tiền rút hôm nay đã đạt đến hạn mức trên. Bạn có cần hoàn tất chứng nhận nâng cao để tăng hạn mức không?',
    restrictedCountriesPayPalAccountToast:
      'Không sử dụng tài khoản PayPal của quốc gia bị hạn chế, điều này sẽ khiến Arripay của bạn bị chặn',
    withdrawMinimumToast: 'Số tiền rút tối thiểu cho mỗi giao dịch: $40',
    bankNotAvailableToast: 'Ngân hàng này không còn khả dụng nữa, vui lòng liên kết với các ngân hàng khác.',
    usdtAccountInvalidToast: 'Tài khoản USDT này không thể rút tiền, vui lòng sử dụng tài khoản mới để rút tiền.',
    noPayPwdToast: 'Vui lòng đặt mật khẩu thanh toán gồm 6 chữ số trước khi rút tiền.',
    editBankAccount: 'Chỉnh sửa Tài khoản Ngân hàng',
    accountPlaceholder: 'Nhập tài khoản của bạn',
    trc20Placeholder: 'nhập địa chỉ TRC-20',
    accountRepeatToast: 'Giống như hiện tại.',
    unbindBankCardConfirmDialog: 'Bạn có chắc chắn muốn hủy liên kết thẻ ngân hàng {0} không?',
    unbindMobileMoneyAccountConfirmDialog: 'Bạn có chắc chắn muốn hủy liên kết tài khoản tiền di động {0} không?',
    unbindAccountConfirmDialog: 'Bạn có chắc chắn muốn hủy liên kết tài khoản {0} không?',
    availableBalance: 'Số dư khả dụng {0}',
    estimatedFee: 'Phí ước tính',
    submitFailToast: 'Gửi không thành công',
    disabledMethodToast: 'Kênh này tạm thời không khả dụng',
    channelUnavailableTitle: 'Kênh không khả dụng',
    channelUnavailableNote: 'Kênh rút tiền này tạm thời không khả dụng. Vui lòng thử cách khác.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Chuyển khoản ngân hàng không khả dụng',
    bankTransferUnavailableNote:
      'Chuyển khoản ngân hàng hiện không khả dụng cho tài khoản của bạn. Vui lòng dùng Epay để rút tiền.',
    channelMaintenanceTitle: 'Kênh đang bảo trì',
    channelMaintenanceNote: 'Kênh rút tiền này đang được bảo trì. Vui lòng thử cách khác.',
    bankInfoUpdateTitle: 'Cập nhật thông tin ngân hàng',
    bankInfoUpdateNote:
      'Do điều chỉnh chính sách của ngân hàng, vui lòng cập nhật thông tin ngân hàng để tiếp tục.',
    bindEpay: 'Liên kết Epay',
    useEpay: 'Dùng Epay',
    iMPSMaxLimitToast: 'Số tiền rút tối đa cho một giao dịch duy nhất thông qua kênh này là 260 đô la',
    linkedAccount: 'Tài khoản đã thêm',
    otherAccounts: 'Có thể thêm các tài khoản khác',
    withdrawTo: 'Chuyển đến',
    withdrawAmount: 'Số tiền chuyển',
    withdrawable: 'Có thể rút',
    documentIdToast: 'Số ID chỉ có thể chứa số',
    noAvailableMethodNote: 'Không có phương thức rút tiền khả dụng',
    recommended: 'Đề xuất'
  },
  paymentCode: {
    changePayPwd: 'Đổi mật khẩu thanh toán',
    setPayPwd: 'Đặt mật khẩu thanh toán',
    setPayPwdNote: 'Vui lòng đặt mật khẩu thanh toán gồm 6 chữ số',
    reenterPayPwdNote: 'Nhập lại',
    verificationNote: 'Vui lòng vượt qua xác minh để đặt mật khẩu.',
    emailVerification: 'Xác minh email',
    inconsistentPasswordToast: 'Mật khẩu không nhất quán',
    payPwdNote: 'Vui lòng nhập mật khẩu thanh toán',
    payPwdFormatToast: 'Mật khẩu thanh toán là số gồm 6 chữ số',
    payPwdWrongToast: 'Mật khẩu thanh toán sai',
    payPwdVerificationFailToast: 'Xác minh mật khẩu thanh toán không thành công!',
    successToast: 'Đặt \n thành công'
  },
  authorize: {
    requirement:
      '{0} cần lấy thông tin sau của MetWallet{1} của bạn để cung cấp dịch vụ liên quan cho bạn. Biệt danh, Ảnh đại diện, Giới tính, v.v.',
    authorize: 'Ủy quyền',
    switchAccount: 'Chuyển đổi tài khoản',
    goToMetWallet: 'Đi đến MetWallet',
    notMatchTips:
      'Hoạt động không thành công. Bạn chỉ có thể bật Đăng nhập nhanh bằng tài khoản MetWallet đã liên kết của mình'
  },
  basicLevel: {
    namePlaceholder: 'Không có ký hiệu, số',
    verification: 'Xác minh',
    whatsAvailable: 'Những gì có sẵn',
    cashOut: 'Rút tiền',
    withdrawLimit: '50 đô la mỗi ngày',
    basicLevelNote: 'Vui lòng nhập thông tin cá nhân thực của bạn. Thông tin sai có thể khiến rút tiền thất bại.',
    fieldEmptyToast: 'Vui lòng điền vào tất cả các trường bắt buộc.',
    successToast: 'Đã lưu \n thành công',
    failToast: 'Lưu không thành công',
    confirmDialog: 'Đảm bảo nhập thông tin cá nhân thực của bạn. Thông tin sai có thể khiến rút tiền thất bại.',
    birthdayFormatToast: 'Định dạng trường Ngày sinh không đúng',
    verificationCodeError: 'Lỗi mã xác minh',
    verificationCodeEmpty: 'Mã xác minh trống',
    noEmailCodeToast: 'Vui lòng lấy mã xác minh email',
    checkDialogTitle: 'Kiểm tra thông tin của bạn',
    checkDialogContent:
      'Để rút tiền thành công, vui lòng kiểm tra thông tin của bạn. Thông tin sai có thể khiến rút tiền thất bại.',
    check: 'Kiểm tra'
  },
  semiVerified: {
    uploadPhotoId: 'Tải lên ảnh ID',
    photoId: 'Ảnh ID',
    resubmit: 'Gửi lại',
    limit: '5.000 đô la mỗi ngày',
    uploading: 'Đang tải lên...',
    notUploadProofToast: 'Vui lòng tải lên bằng chứng về thẻ căn cước'
  },
  fullyVerified: {
    frontOfId: 'Mặt trước giấy tờ',
    backOfId: 'Mặt sau giấy tờ',
    uploadIdFront: 'Tải lên mặt trước',
    uploadIdBack: 'Tải lên mặt sau',
    withdrawDailyHint: 'Điền thông tin để rút tiền > {0} mỗi ngày.',
    notUploadIdToast: 'Vui lòng tải lên mặt trước và mặt sau giấy tờ',
    proofTitle: 'GIẤY TỜ CHỨNG MINH CƯ TRÚ',
    acceptableProof: 'BẰNG CHỨNG MINH CƯ TRÚ ĐƯỢC CHẤP NHẬN LÀ:',
    acceptableProof1: 'Sao kê tài khoản ngân hàng.',
    acceptableProof2: 'Hóa đơn tiện ích (điện, nước, internet, v.v.).',
    acceptableProof3: 'Giấy tờ do chính phủ cấp (báo cáo thuế, giấy chứng nhận cư trú, v.v.).',
    unacceptableProof:
      'Chúng tôi không thể chấp nhận địa chỉ trên giấy tờ tùy thân bạn đã nộp là bằng chứng cư trú hợp lệ.',
    limit: '10.000 đô la mỗi ngày',
    notUploadToast: 'Vui lòng tải lên giấy tờ chứng minh cư trú',
    incorrectFormatToast: 'Vui lòng tải lên ảnh jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Mật khẩu',
    lastLogin: 'Lần đăng nhập cuối',
    moreOptions: 'Thêm tùy chọn',
    agreeCheckboxContent: 'Đồng ý với {0} và {1}',
    userAgreement: 'Thỏa thuận người dùng',
    privacyPolicy: 'Chính sách bảo mật',
    notAgreeToast: 'Đồng ý với Thỏa thuận người dùng và Chính sách bảo mật',
    forgotPassword: 'Quên mật khẩu',
    linkedMail: 'Thư được liên kết',
    verificationCode: 'Mã xác minh',
    newPwd: 'Mật khẩu mới',
    repeatPwd: 'Nhập lại mật khẩu',
    confirmPwd: 'Xác nhận mật khẩu',
    noLinkedEmailToast: 'Không có email được liên kết với tài khoản của bạn',
    unregisteredToast: 'Số này chưa được đăng ký',
    pwdFormatToast: 'Định dạng mật khẩu không đúng',
    resetSuccessToast: 'Đặt lại \n thành công',
    pwdNotMatchToast: 'Mật khẩu không khớp hai lần',
    emailFormatToast: 'Định dạng email sai',
    phoneNumberFormatToast: 'Định dạng số điện thoại sai',
    invalidAreaCodeToast: 'Mã vùng không hợp lệ',
    login: 'Đăng nhập',
    pwdLogin: 'Đăng nhập bằng mật khẩu',
    emailCodeLogin: 'Đăng nhập qua mã xác minh email',
    smsLogin: 'Đăng nhập qua SMS',
    verifyEmail: 'Xác minh email',
    verifyPhone: 'Xác minh số điện thoại',
    accountDangerDialog:
      'Tài khoản của bạn đã được phát hiện có nguy hiểm. Vui lòng xác minh lại tài khoản của bạn, nếu không tài khoản của bạn sẽ không thể tiếp tục sử dụng.',
    sendEmailCodeDialog: 'Chúng tôi đã gửi mã xác minh đến email {0} của bạn. Vui lòng nhập mã xác minh.',
    sendSmsCodeDialog: 'Chúng tôi đã gửi mã xác minh đến điện thoại {0} của bạn. Vui lòng nhập mã xác minh.',
    graphicCodeEmptyToast: 'Vui lòng nhập mã đồ họa.',
    countryUnselectToast: 'Vui lòng chọn quốc gia của bạn trước',
    unsupportedLoginTypeToast: 'Kiểu đăng nhập không được hỗ trợ',
    pwdWrongLimitOverDialog: 'Đã nhập sai mật khẩu 3 lần. Vui lòng sử dụng mã xác minh SMS để đăng nhập.',
    loginFailedToast: 'Đăng nhập không thành công',
    signIn: 'Đăng nhập',
    pwdPlaceholder: 'Nhập mật khẩu',
    pwdNote: 'Nhập 8-16 ký tự bao gồm chữ cái và số',
    reenterPwdPlaceholder: 'Nhập lại mật khẩu',
    reenterPwdNote: 'Vui lòng nhập lại mật khẩu',
    createAccount: 'Tạo tài khoản',
    chooseCountryNote: 'Vui lòng chọn quốc gia',
    pwdInconsistentToast: 'Không giống với mật khẩu trước đó bạn đã nhập',
    createSuccessToast: 'Tạo \n thành công',
    registerFailToast: 'Đăng ký không thành công',
    userNotExistToast: 'Người dùng không tồn tại',
    phoneIncorrectToast: 'Vui lòng kiểm tra điện thoại của bạn',
    userExistToast: 'Người dùng đã tồn tại',
    countryCodeRepeatToast: 'Vui lòng không nhập mã quốc gia nhiều lần!',
    logoutDialog: 'Bạn có chắc chắn muốn đăng xuất không?',
    pwdRequirement: 'Mật khẩu phải có ít nhất 8 đến 16 ký tự bao gồm chữ cái và số',
    signup: 'Đăng ký',
    registerSuccessToast: 'Đăng ký \n thành công',
    oldPwdErrorToast: 'Vui lòng kiểm tra mật khẩu cũ của bạn'
  },
  checkUserInfo: {
    title: 'Trung tâm quản lý',
    emptyInfoNote:
      'Không có thông tin nào cho tài khoản hiện tại, vui lòng kiểm tra tài khoản MetWallet mà bạn cần xác minh.',
    infoNote: 'Đây là thông tin xác minh của bạn.',
    lastSuccessWithdrawal: 'Rút tiền thành công gần đây nhất',
    copyBtn: 'Sao chép',
    successToast: 'Đã sao chép thành công!',
    failToast: 'Không sao chép được!'
  },
  country: {
    title: 'Chọn khu vực',
    popular: 'Phổ biến'
  },
  documentDetails: {
    title: 'Chi tiết tài liệu',
    contract: 'Hợp đồng',
    goToSign: 'Đi đến ký',
    download: 'Tải xuống',
    upload: 'Tải lên',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., chỉ tài liệu.',
    contentEmptyToast: 'Vui lòng nhập nội dung',
    placeOfBirth: 'Nơi sinh',
    occupation: 'Nghề nghiệp',
    fileForm: '(Biểu mẫu tệp)',
    proofOfAddress: 'Bằng chứng về địa chỉ bằng tiếng Anh',
    residenceDoc: 'Giấy tờ cư trú',
    textForm: '(Biểu mẫu văn bản)',
    contractAgent: 'Đại lý hợp đồng',
    contractPayslip: 'Phiếu lương hợp đồng',
    uncompletedToast: 'Vui lòng điền để gửi',
    successToast: 'Gửi thành công',
    undefinedFileTypeToast: 'Loại tệp tải lên không xác định',
    uploadFailToast: 'Tải lên không thành công'
  },
  filters: {
    amount: 'Số tiền',
    filter: 'Bộ lọc',
    time: 'Thời gian',
    reset: 'Đặt lại',
    timePickerTitle: 'Chọn {0} Thời gian',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    maximum: 'Tối đa',
    minimum: 'Tối thiểu'
  },
  home: {
    balance: 'Số dư',
    transactions: 'Giao dịch',
    availableBalance: 'Số dư khả dụng',
    noWithdrawalMethodToast: 'Cần có ít nhất một phương thức rút tiền.',
    linkAccount: 'Liên kết tài khoản',
    all: 'Tất cả',
    cashIn: 'Tiền mặt',
    loading: 'Đang tải...',
    noMore: 'Không còn giao dịch nào nữa',
    reload: 'Không tải được, hãy nhấp để tải lại',
    receivedFrom: 'Đã nhận từ',
    transferredTo: 'Đã chuyển đến',
    fee: 'Phí chuyển đến',
    myEmail: 'Email của tôi',
    myPhone: 'Điện thoại của tôi',
    invalidBasicLevelDialog:
      'Do trường tên của bạn có chứa ký hiệu, khoảng trắng hoặc số nên không thể rút tiền từ tài khoản. Vui lòng điền lại thông tin cơ bản (đảm bảo rằng tên không bao gồm ký hiệu, khoảng trắng hoặc số và nếu bạn không có họ hoặc tên đệm, hãy để trống.)',
    lackLastNameDialog: 'Họ của bạn không được điền, điều này sẽ cản trở việc rút tiền của bạn.',
    fillIn: 'Điền vào',
    viewDetails: 'Xem chi tiết',
    docReviewingDialogTitle: 'Vui lòng đợi tài liệu được thông qua.',
    docReviewingDialogContent:
      'Bạn đã gửi tài liệu, nhưng bạn không thể sử dụng MetWallet trước khi tài liệu của bạn được thông qua.<br>Nhân viên chính thức sẽ sớm xử lý, vui lòng đợi một lúc.',
    docPassedDialog: 'Tài liệu bạn đã gửi đã được thông qua. <br>Bây giờ bạn có thể sử dụng MetWallet bình thường.',
    docUnqualifiedDialog: 'Tài liệu bạn đã gửi không đủ điều kiện. <br>Vui lòng gửi một tài liệu đủ điều kiện.',
    goToSubmit: 'Hãy gửi đi',
    uncompletedDialog: 'Bạn phải hoàn thành để sử dụng MetWallet bình thường',
    useMetWalletNormallyAfterPassed: 'Bạn có thể sử dụng MetWallet bình thường sau khi tài liệu được thông qua.',
    requireSemiVerifiedDialog:
      '{0}, theo yêu cầu của ngân hàng, bạn phải hoàn thành phần đã xác minh một phần trong vòng 48 giờ để rút tiền thành công.',
    goToVerify: 'Hãy xác minh',
    emailInvalidDialog:
      '{0}, địa chỉ email của bạn giống với địa chỉ email của người khác. Để bảo vệ quyền riêng tư, vui lòng nhập địa chỉ email của riêng bạn càng sớm càng tốt.',
    later: 'Sau đó',
    transferRequireSemiVerifiedDialog: 'Vui lòng hoàn tất xác minh bán xác minh trước khi chuyển.',
    modifyBtnText: 'Sửa Thông Tin Của Tôi',
    unmodifiedTitle: 'Không thể sửa đổi',
    unmodifiedContent: 'Bạn có một lệnh rút tiền đang được xử lý. Thông tin không thể sửa đổi ngay bây giờ.'
  },
  signing: {
    signature: 'Chữ ký',
    date: 'Ngày',
    employeeName: 'Tên nhân viên',
    designation: 'Chức danh',
    month: 'Tháng',
    year: 'Năm',
    earnings: 'Thu nhập',
    deductions: 'Trừ trừ',
    basic: 'Cơ bản & DA (USD)',
    totalAddition: 'Tổng cộng',
    totalDeduction: 'Tổng khấu trừ',
    salary: 'Lương NET',
    refNo: 'Số tham chiếu',
    paymentTransferDate: 'Ngày chuyển khoản thanh toán',
    nameOfBank: 'Tên ngân hàng',
    signatureOfEmployee: 'Chữ ký của nhân viên',
    director: 'Giám đốc',
    signNote: 'Vui lòng ký tên của bạn',
    preview: 'Xem trước',
    clear: 'Xóa',
    save: 'Lưu',
    noSignatureToast: 'Bạn không thể lưu nếu không có chữ ký.',
    fieldEmptyToast: 'Vui lòng điền đầy đủ thông tin.'
  },
  transactionDetail: {
    title: 'Chi tiết giao dịch',
    status: 'Trạng thái',
    pending: 'Đang chờ',
    completed: 'Hoàn thành',
    success: 'THÀNH CÔNG',
    failed: 'Thất bại',
    cancelled: 'Đã hủy',
    onHold: 'Đang giữ',
    reason: 'Lý do trạng thái',
    description: 'Mô tả',
    creationDate: 'Ngày tạo',
    lastStatusDate: 'Ngày trạng thái cuối cùng',
    requestedAmount: 'Số tiền yêu cầu',
    receiveAmount: 'Số tiền nhận được',
    transferAmount: 'Số tiền chuyển',
    amountToPay: 'Số tiền phải trả',
    transferFee: 'Phí chuyển khoản',
    processingFee: 'Phí xử lý',
    method: 'Phương thức',
    country: 'Quốc gia',
    name: 'Quốc gia của tài liệu',
    bankPendingText: 'Đang xem xét ngân hàng cuối cùng',
    pendingText: 'Đang xem xét {0}',
    chametSalary: 'Lương Chamet',
    userSalary: 'Lương người dùng',
    comm: 'Truyền thông',
    gemgalaSalary: 'Mức lương Gemgala'
  },
  transfer: {
    title: 'Đến tài khoản MetWallet',
    noPayPwdDialog: 'Vui lòng đặt mật khẩu thanh toán gồm 6 chữ số trước khi chuyển khoản.',
    records: 'Hồ sơ',
    cashInOut: 'Nạp tiền {0}, Rút tiền {1}',
    transfer: 'Chuyển',
    fee: 'Phí',
    remark: 'Ghi chú',
    transferTo: 'Chuyển đến {0}',
    remarkPlaceholder: 'Thêm ghi chú chuyển tiền (ít hơn 100 ký tự)',
    firstNameNote: 'Vui lòng nhập tên của người đó',
    sendingAmount: 'Số tiền gửi',
    receivingAmount: 'Số tiền nhận',
    transferNow: 'Chuyển ngay',
    noBalanceToast: 'Số tiền chuyển lớn hơn số dư.',
    amountTooLittleToast: 'Số tiền chuyển không được nhỏ hơn $10.'
  },
  bankData: {
    beneficiaryName: 'Tên người thụ hưởng',
    beneficiaryNamePlaceholder: 'Nhập tên',
    beneficiaryLastname: 'Họ người thụ hưởng',
    beneficiaryLastnamePlaceholder: 'Nhập họ',
    bankCode: 'Mã ngân hàng',
    bankCodePlaceholder: 'Chọn mã ngân hàng',
    bankIFSCCode: 'Mã IFSC của ngân hàng',
    bankIFSCCodePlaceholder: 'Nhập IFSC của ngân hàng',
    bankAccount: 'Tài khoản ngân hàng',
    bankAccountPlaceholder: 'Nhập tài khoản ngân hàng',
    email: 'Email',
    emailPlaceholder: 'Nhập email',
    phoneNumber: 'Số điện thoại',
    phoneNumberPlaceholder: 'Nhập số điện thoại',
    address: 'Địa chỉ',
    addressPlaceholder: 'Nhập địa chỉ',
    city: 'Thành phố',
    cityPlaceholder: 'Nhập thành phố',
    state: 'Tiểu bang',
    statePlaceholder: 'Nhập tiểu bang',
    postCode: 'Mã bưu chính',
    postCodePlaceholder: 'Nhập mã bưu chính',
    documentId: 'ID tài liệu',
    documentIdPlaceholder: 'Nhập ID tài liệu',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Loại tài liệu',
    documentTypePlaceholder: 'Chọn loại tài khoản',
    accountType: 'Chọn loại tài khoản',
    accountTypePlaceholder: 'Nhập CPFCNPJ',
    cpfcnpjPlaceholder: 'Chi nhánh ngân hàng',
    bankBranch: 'Nhập Chi nhánh ngân hàng',
    bankBranchPlaceholder: 'RIB của tài khoản ngân hàng',
    ribOfBankAccount: 'Tên ngân hàng',
    bankName: 'Nhập tên ngân hàng',
    bankNamePlaceholder: 'Mã BIC',
    bicCode: 'Nhập mã BIC',
    bicCodePlaceholder: 'Nhập IBAN',
    ibanPlaceholder: 'Swift của ngân hàng',
    bankSwift: 'Nhập Swift của ngân hàng',
    bankSwiftPlaceholder: 'Tên',
    name: 'Quốc gia của tài liệu',
    documentCountry: 'Chọn quốc gia của tài liệu',
    documentCountryPlaceholder: 'Ngày phát hành tài liệu',
    issueDate: 'Chọn ngày phát hành',
    issueDatePlaceholder: 'Ngày hết hạn của tài liệu',
    expireDate: 'Chọn ngày hết hạn',
    expireDatePlaceholder: 'Tên chi nhánh ngân hàng',
    bankBranchName: 'Nhập tên chi nhánh',
    bankBranchNamePlaceholder: 'Nhập chi nhánh',
    branchPlaceholder: 'Giới tính',
    gender: 'Chọn giới tính',
    genderPlaceholder: 'Sinh nhật',
    birthday: 'Chọn sinh nhật',
    birthdayPlaceholder: 'Điện thoại',
    phone: 'Địa chỉ ngân hàng',
    bankAddress: 'Nhập địa chỉ ngân hàng',
    bankAddressPlaceholder: 'Tên tài khoản ngân hàng',
    bankAccountName: 'Nhập tên tài khoản ngân hàng',
    bankAccountNamePlaceholder: 'Nhập tên tài khoản ngân hàng',
    province: 'Tỉnh',
    provincePlaceholder: 'Nhập Tỉnh',
    postalCode: 'Bưu chính Mã',
    postalCodePlaceholder: 'Nhập Mã bưu chính',
    savingsAccount: 'Tài khoản tiết kiệm',
    abaRoutingNumber: 'Số định tuyến ABA',
    englandBankAccount: 'Tài khoản Ngân hàng Anh',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Chỉ khi ngân hàng là Santander',
    paternalName: 'Tên cha',
    paternalNamePlaceholder: 'Nhập Tên cha',
    passportIdNumber: 'Số ID hộ chiếu',
    bankNamePlaceholder2: 'Chọn Tên ngân hàng',
    areaCode: 'Mã vùng',
    phoneNumberNoAreaCode: 'Số điện thoại (Không có mã vùng)',
    idType: 'Loại ID',
    idNo: 'Số ID',
    idIssueDate: 'Ngày cấp ID',
    idExpireDate: 'Ngày hết hạn ID',
    ibanStyleToast: "Vui lòng nhập nội dung bắt đầu bằng 'SA' với độ dài 24 ký tự."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'Bạn chỉ có thể chuyển đến Người bán kim cương',
    search: 'Tìm kiếm',
    history: 'Người dùng đã chuyển',
    confirm_content: 'Bạn có chắc chắn muốn chuyển {0} đến {1} không',
    success_content: '{0} đã được chuyển đến {1}',
    purchase: 'Mua',
    purchase_success: 'Bạn đã mua thành công {0}',
    insufficient_balance: 'Số dư không đủ',
    purchase_diamond: 'Mua kim cương',
    transfer_limit_2: 'Số tiền chuyển phải nằm trong khoảng từ $10 đến $30.000',
    no_data: 'Không có dữ liệu',
    invalid_number: 'Vui lòng nhập số hợp lệ',
    under_limit: 'Số tiền chuyển phải không ít hơn $10',
    over_limit: 'Số tiền chuyển phải ít hơn $30.000'
  },
  redesign: {
    emailPlaceholder: 'Nhập địa chỉ email',
    retrievePwd: 'Lấy lại mật khẩu',
    resetPwd: 'Đặt lại mật khẩu',
    newPwdPlaceholder: 'Nhập mật khẩu mới',
    reenterNewPwdPlaceholder: 'Nhập lại mật khẩu mới',
    reenterPayPwdPlaceholder: 'Vui lòng nhập lại mật khẩu thanh toán',
    sendToPhone: 'Mã xác minh đã được gửi đến điện thoại của bạn',
    sendToWhatsapp: 'Mã xác minh đã được gửi đến WhatsApp của bạn',
    sendToEmail: 'Mã xác minh đã được gửi đến email của bạn',
    invalidCode: 'Mã không hợp lệ',
    userId: 'ID người dùng',
    other: 'Khác',
    transactionRecord: 'Bản ghi giao dịch',
    bankCardInfo: 'Tài khoản thẻ ngân hàng',
    withdrawInfo: 'Tài khoản rút tiền',
    toFillIn: 'Cần điền',
    walletInfo: 'Thông tin tài khoản ví',
    toComplete: 'Cần hoàn tất',
    verifyGuide: 'Hoàn tất thông tin tài khoản ví để có thêm điều kiện rút tiền',
    verifyNote: 'Hoàn tất thông tin sau để có đủ điều kiện rút tiền hàng ngày là {0}',
    verifyCompletedNote: 'Thông tin đã hoàn tất để có đủ điều kiện rút tiền hàng ngày là {0}',
    continueBtnText: 'Tiếp tục điền vào',
    submitInfo: 'Gửi thông tin',
    transferAmount: 'Số tiền chuyển',
    newEmailVerify: 'Xác minh email mới',
    verifyCodePlaceholder: 'Nhập mã xác minh',
    emailIncorrectToast: 'Vui lòng nhập địa chỉ email chính xác',
    newPhone: 'Số điện thoại mới',
    accountAdded: 'Đã thêm thông tin tài khoản',
    accountToAdd: 'Có thể thêm các tài khoản khác',
    edit: 'Chỉnh sửa',
    enterPayPwd: 'Nhập mật khẩu thanh toán',
    deleteBtnText: 'Xóa',
    transferTo: 'Chuyển đến',
    withdrawable: 'Có thể rút',
    goSet: 'Đi thiết lập',
    goModify: 'Đi sửa đổi'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/vi.js